import type { DeepRequired } from '../fixtures.types'

const protectionProduct: DeepRequired<ProtectionProduct> = {
  __typename: 'ProtectionProduct',
  protection_id: 'TEST_ID',
  created_at: null,
  version: '1',
  version_created_at: null,
  details: {
    __typename: 'ProtectionProductDetails',
    client_ids: [],
    end_date: null,
    policy_number: null,
    premium_frequency: null,
    not_proceeding_details: null,
    premium_change_reason: null,
    documents: {
      __typename: 'ProductDocuments',
      application_doc_id: null,
      commission_comparison_report_doc_id: null,
      illustration_doc_id: null,
      key_facts_doc_id: null,
      comparison_report_doc_id: null,
      policy_letter_doc_id: null,
    },
    product_benefits: {
      __typename: 'ProductBenefit',
      product_key_man: null,
      product_type_child_accident_sickness: null,
      product_type_core_accident_sickness: null,
      product_type_family_income_benefit: null,
      product_type_group_life: null,
      product_type_group_asu: null,
      product_type_group_cic: null,
      product_type_group_ip: null,
      product_type_group_pmi: null,
      product_type_income_protection: null,
      product_type_other: null,
      product_type_pmi: null,
      product_type_shareholder_protection: null,
      product_type_specialist_healthcare_cover: null,
      product_type_sports_lifestyle: null,
      product_type_term: null,
      product_type_whole_of_life: null,
      product_type_private_medical_insurance: null,
      product_type_group_private_medical_insurance: null,
      product_type_employee_benefit: null,
      product_type_executive_ip: null,
      product_type_relevant_life: [
        {
          __typename: 'ProtectionProductBenefitItem',
          client_ids: [],
          cover_amount: null,
          cover_amount_frequency: null,
          premium_type: null,
          term_years: null,
          additional_cover_amount: null,
          additional_deferral_period_days: null,
          cost_amount: null,
          cost_amount_frequency: null,
          cover_amount_cic: null,
          cover_amount_depreciation_rate: null,
          cover_amount_life: null,
          cover_amount_life_or_earlier_cic: null,
          cover_amount_type: null,
          deferral_period_days: null,
          deferral_period: null,
          dual_defer_init_amount: null,
          dual_defer_init_defer: null,
          include_limited_benefit_payment_period: null,
          indexation: null,
          indexation_percentage: null,
          indexation_type: null,
          payout_type: null,
          product_type: null,
          product_type_other: null,
          product_type_other_name: null,
          term_age: null,
          units_of_cover: null,
          additional_notes: null,
          cancer_cover: null,
          dental_and_optical: null,
          dental: null,
          optical: null,
          full_diagnostics: null,
          claim_in_five_years: null,
          claim_details: null,
          policy_exclusion_details: null,
          excess_amount: null,
          hospital_list: null,
          mental_health: null,
          outpatient_cover: null,
          outpatient_cover_details: null,
          outpatient_full_cover: null,
          physiotherapy: null,
          private_gp_cover: null,
          product_add_ons: null,
          six_week_option: null,
          therapies: null,
          travel_international: null,
          underwriting_level: null,
          age_banded: null,
          limited_payment_plan: null,
        },
      ],
    },
    solution_type: null,
    product_details: null,
    product_name: null,
    provider_name: null,
    recommendation_premium_amount: null,
    start_date: null,
    status: null,
    underwritten_premium_amount: null,
    source_response: null,
    solution_products: [],
    is_employment_benefit: null,
    is_business_protection: null,
    keep_existing_policy: null,
    is_renewal: null,
    product_recommendation_justification: null,
    product_benefit_group_id: null,
    recommended_case: null,
    case_ids: [],
    org_provider_reference: null,
    cancellation_date: null,
    commission: null,
    errors: [],
    modified_at: null,
    source: null,
    warnings: [],
    external: [],
  },
}

export default protectionProduct
